import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';

@Component({
  selector: 'aid-info-display-data',
  template: `
    <div class="data aid-layout-row aid-layout-align-space-between">
      <div class="aid-layout-row aid-layout-align-start-start aid-flex-50">
        <span class="data__label mat-subtitle-2">
          {{ label | translate | sentancecase }}
        </span>
      </div>

      <div class="aid-layout-row aid-layout-align-start-start aid-flex-50">
        @if (!translate) {
          <span class="data__value mat-subtitle-2">
            {{ value || '-' }}
          </span>
        }
        @if (translate) {
          <span class="data__value mat-subtitle-2">
            {{ (value | translate) || '-' }}
          </span>
        }
      </div>
    </div>
  `,
  styleUrls: ['./info-display-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class InfoDisplayDataComponent implements OnInit {
  @Input() label?: string;
  @Input() value?: string | null;
  @Input() translate?: boolean;
  constructor() {}

  ngOnInit() {}
}
